import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useRacehorse360Api } from "hooks/api";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import Logo from "components/Icons/Logo";
import useStyles from "./styles";
import Fade from "@material-ui/core/Fade";

const SplashScreen = () => {
  const classes = useStyles();
  const { currentUser } = useLoggedInUser();
  const { useGetUser } = useRacehorse360Api();
  const [show, setShow] = useState<boolean>(true);

  const { data: user } = useGetUser(
    `${currentUser.rh360Id}-initial-loading`,
    {
      id: currentUser.rh360Id,
      getOptions: {
        select: ["firstName", "lastName"]
      }
    },
    {
      enabled: Boolean(currentUser.rh360Id),
      onSuccess: () => {
        setTimeout(() => {
          setShow(false);
        }, 2000);
      }
    }
  );

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [show]);

  return (
    <Fade in={show} mountOnEnter unmountOnExit timeout={{ enter: 0 }}>
      <div className={clsx(classes.root)}>
        {user ? (
          <div className={classes.greetingsWrapper}>
            <div className={classes.greetings}>
              <div className={classes.greetingsWelcome}>WELCOME,</div>
            </div>
            <div className={classes.greetings}>
              <div className={classes.greetingsName}>
                {user.firstName} {user.lastName}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <Logo className={classes.logoBg} />
      </div>
    </Fade>
  );
};

export default SplashScreen;
